document.addEventListener('DOMContentLoaded', () => {
    let selects = document.querySelectorAll('.jsSelectLinks');

    for (let index = 0; index < selects.length; index++) {
        const item = selects[index];
        let trigger = item.querySelector('.jsSelectTrigger');
        let placeholder = trigger.querySelector('span');
        let dropdown = item.querySelector('.jsSelectDropdown');

        document.addEventListener('click', (e) => {
            const target = e.target 
            if (item.classList.contains('is-open') && (!target.closest('.jsSelectLinks'))) {
                item.classList.remove('is-open')
            }
        })

        trigger.addEventListener('click', () => {
            item.classList.toggle('is-open');
        })
    }
})